export default {
  REPLY: 'Reply',
  COMMENTS: 'Comments',
  WRITE_COMMENT: 'Write comment',
  THERE_ARE_NO_COMMENTS: 'There are no comments',
};
